import { App } from "app-interfaces";
import React from "react";

import CatalogClass from "../models/Catalog";
import EventsClass from "../models/Events";
import { ScoreType } from "../types/StaticTypes";

export const InitialState: App.State = {
  authenticated: false,
  metric: true,
  showLoadingModal: false,
  showModal: false,
  modalMessage: "",
  modalTitle: "",
  countries: [],
  events: new EventsClass(),
  catalog: new CatalogClass(),
};

const AppContext = React.createContext<Partial<App.State>>(InitialState);

export default AppContext;
export const { Consumer, Provider } = AppContext;
export const useStateValue = () => React.useContext(AppContext);

// Helper Functions
export function calcAge(params: string | number | Date) {
  const birthYear = new Date(params).getFullYear();
  const currentYear = new Date().getFullYear();
  return currentYear - birthYear;
}

// Reorder Array Items
export const reorderItems = (from: number, to: number, source: any[]) => {
  const movedItem = source[from];
  const remainingItems = source.filter((el, i) => i !== from);
  return [...remainingItems.slice(0, to), movedItem, ...remainingItems.slice(to)];
};

// Get unit is Integer
export const isScoreTypeWithIntegerValues = (name: string) => {
  switch (name) {
    case `${ScoreType[ScoreType.REPS]}`:
    case `${ScoreType[ScoreType.INCLINE]}`:
    case `${ScoreType[ScoreType.PULSE]}`:
    case `${ScoreType[ScoreType["RPE/BORG"]]}`:
    case `${ScoreType[ScoreType.WATT]}`:
      return true;
    default:
      return false;
  }
};

// Get metric units
export const metricUnit = (name: string, metric: boolean) => {
  switch (name) {
    case `${ScoreType[0]}`:
    case `${ScoreType[3]}`:
      return "(mm.ss)";
    case `${ScoreType[0]}O`:
    case `${ScoreType[3]}O`:
      return "Mins";
    case `${ScoreType[2]}`:
      return metric ? "(km)" : "(miles)";
    case `${ScoreType[2]}O`:
      return metric ? "Kms" : "Miles";
    case `${ScoreType[1]}`:
      return "(reps)";
    case `${ScoreType[1]}O`:
      return "Reps";
    case `${ScoreType[4]}`:
      return metric ? "Kg" : "(pounds)";
    case `${ScoreType[4]}O`:
      return metric ? "Kgs" : "(Pounds)";
    case `${ScoreType[5]}`:
    case `${ScoreType[5]}O`:
      return "(%)";
    case `${ScoreType[6]}`:
      return metric ? "(kph)" : "(mph)";
    case `${ScoreType[6]}O`:
      return metric ? "Kph" : "Mph";
    case `${ScoreType[10]}`:
      return "(w)";
    case `${ScoreType[10]}O`:
      return "W";
    case "height":
      return metric ? "cm" : "ft";
    default:
      return "";
  }
};
// Unit Converter
export const metricConverter = (raw: number, name?: string, metric: boolean = true) => {
  const conversions = {
    KG_TO_G: 1000,
    FOOT_TO_CM: 30.48,
    INCH_TO_CM: 2.54,
    KM_TO_M: 1000,
    MILES_TO_M: 1609.34,
    POUND_TO_G: 453.592,
  };
  let result: number;

  switch (name) {
    case `${ScoreType[2]}`: //Input LENGTH, convert Meter to KM / Mile
    case `${ScoreType[6]}`: //Input SPEED, convert Meter to KM / Mile
      if (metric) result = raw / conversions.KM_TO_M;
      else {
        result = raw / conversions.MILES_TO_M;
      }
      break;
    case `${ScoreType[4]}`: //Input KG_WEIGHT, convert G to KG / Pound
      if (metric) result = raw / conversions.KG_TO_G;
      else {
        result = raw / conversions.POUND_TO_G;
      }
      break;
    case "height":
      if (metric) result = raw;
      else {
        result = raw / conversions.FOOT_TO_CM;
      }
      break;
    case `${ScoreType[2]}O`: //Output LENGTH, convert KM / Mile to Meter
    case `${ScoreType[6]}O`: //Output SPEED, convert KM / Mile to Meter
      if (metric) result = raw * conversions.KM_TO_M;
      else {
        result = raw * conversions.MILES_TO_M;
      }
      break;
    case `${ScoreType[4]}O`: //Out KG_WEIGHT, convert KG / Pound to G
      if (metric) result = raw * conversions.KG_TO_G;
      else {
        result = raw * conversions.POUND_TO_G;
      }
      break;
    case "heightO":
      if (metric) result = raw;
      else {
        result = raw * conversions.FOOT_TO_CM;
      }
      break;
    default:
      result = raw;
  }
  // return result;
  return Math.round(result * Math.pow(10, 2)) / Math.pow(10, 2);
};
